export default __webpack_public_path__ + "static/media/PresentationTwitterBotEdit.7d4856ad.jpg";